const errorMessages = {
  // TODO: uzupełnić :)
};

const specificErrorMessagesForDedicatedUrl = {
  /* example */
  [`${process.env.VUE_APP_API_URL}/endpoint`]: {
    title: 'Some title',
    message: 'Some message',
  },
};

export const prepareErrorMessageForNotAcceptableStatus = (errorData, errorUrl) => {
  // get only first error
  const mismatchValue = Object.keys(errorData)[0];
  const mismatchType = errorData[mismatchValue][0];

  return specificErrorMessagesForDedicatedUrl[errorUrl] || (errorMessages[mismatchValue]
    ? errorMessages[mismatchValue][mismatchType] : {
      title: 'Błąd',
      message: 'Wystąpił błąd podczas wykonywania operacji',
    });
};
